(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fall-sale-hero-wandor"] && !Shopify.designMode) return;
  try {
    
function isConstrainedConnection(connection) {
  return Boolean(connection?.saveData || ['slow-2g', '2g', '3g'].includes(connection?.effectiveType) || (connection?.downlink > 0 && connection.downlink < 1.5));
}

function mountHeroMedia(root) {
  const video = root.querySelector('[data-hero-video]');
  const button = root.querySelector('[data-hero-motion]');
  const preference = matchMedia('(prefers-reduced-motion: reduce)');
  const connection = navigator.connection;
  const events = new AbortController();
  const listen = (target, type, handler) => target?.addEventListener(type, handler, { signal: events.signal });
  const shouldPause = () => preference.matches || root.dataset.autoplay !== 'true' || (root.dataset.protectData !== 'false' && isConstrainedConnection(connection));
  let alive = true;
  let paused = shouldPause();
  let primed = false;
  let priming = false;
  let hasFrame = false;
  let epoch = 0;
  let deadline;
  let imageDeadline;
  let startDelay;
  let paintFrame;
  let decodedFrame;
  const bounds = root.getBoundingClientRect();
  let inView = bounds.bottom > 0 && bounds.top < innerHeight;
  root.dataset.media = 'poster';
  root.dataset.videoReady = 'false';
  const away = () => document.hidden || !inView;

  const clearDeadline = () => { clearTimeout(deadline); deadline = undefined; };
  const cancelFrame = () => {
    if (decodedFrame !== undefined) video?.cancelVideoFrameCallback?.(decodedFrame);
    decodedFrame = undefined;
  };
  const releaseVideo = () => {
    epoch += 1;
    clearDeadline();
    cancelFrame();
    if (video?.hasAttribute('src')) {
      video.pause();
      video.removeAttribute('src');
      video.load();
    }
    hasFrame = false;
    root.dataset.videoReady = 'false';
  };
  const updateLabels = () => {
    root.dataset.motion = paused ? 'paused' : 'playing';
    root.toggleAttribute('data-away', away());
    if (button) {
      button.hidden = false;
      button.setAttribute('aria-label', paused ? root.dataset.playLabel : root.dataset.pauseLabel);
    }
  };
  const fallback = reason => {
    if (!alive) return;
    releaseVideo();
    paused = true;
    root.dataset.media = 'fallback';
    root.dataset.videoError = reason;
    updateLabels();
  };
  const armDeadline = duration => {
    if (deadline === undefined) deadline = setTimeout(() => fallback('timeout'), duration);
  };
  const revealFrame = () => {
    if (!alive || paused || away() || !video?.hasAttribute('src')) return;
    clearDeadline();
    hasFrame = true;
    root.dataset.videoReady = 'true';
    root.dataset.media = 'playing';
  };
  const startVideo = () => {
    if (!alive || !video || paused || !primed || away()) return;
    if (hasFrame && !video.paused) return;
    if (!video.hasAttribute('src')) {
      const mobile = matchMedia('(max-width: 760px)').matches;
      const source = (mobile && root.dataset.videoMobile) || root.dataset.videoDesktop;
      if (!source) return;
      epoch += 1;
      delete root.dataset.videoError;
      root.dataset.media = 'loading';
      video.muted = true;
      video.src = source;
      video.load();
    }
    const requestEpoch = epoch;
    armDeadline(6000);
    void video.play().catch(() => {
      if (alive && requestEpoch === epoch && !paused && !away()) fallback('playback');
    });
  };
  const update = () => {
    updateLabels();
    if (paused || away()) {
      clearDeadline();
      cancelFrame();
      if (hasFrame) { video?.pause(); root.dataset.media = 'paused'; }
      else if (video?.hasAttribute('src')) { releaseVideo(); root.dataset.media = 'poster'; }
    } else startVideo();
  };

  listen(video, 'playing', () => {
    cancelFrame();
    if (hasFrame || !video.requestVideoFrameCallback) revealFrame();
    else {
      const frameEpoch = epoch;
      decodedFrame = video.requestVideoFrameCallback(() => {
        decodedFrame = undefined;
        if (frameEpoch === epoch) revealFrame();
      });
    }
  });
  listen(video, 'error', () => { if (video.hasAttribute('src')) fallback('network'); });
  for (const event of ['waiting', 'stalled']) listen(video, event, () => {
    if (video.readyState >= 3) return;
    if (!paused && !away() && video.hasAttribute('src')) armDeadline(hasFrame ? 4000 : 6000);
  });
  listen(button, 'click', () => {
    paused = !paused;
    if (!paused) { primed = true; clearTimeout(imageDeadline); }
    update();
  });
  listen(document, 'visibilitychange', update);
  listen(preference, 'change', () => { paused = shouldPause(); update(); });
  listen(connection, 'change', () => {
    if (root.dataset.protectData !== 'false' && isConstrainedConnection(connection)) { paused = true; update(); }
  });
  const observer = typeof IntersectionObserver === 'undefined' ? null : new IntersectionObserver(entries => {
    inView = entries[0].isIntersecting;
    update();
  }, { threshold: 0.05 });
  observer?.observe(root);

  const pending = new Set([...root.querySelectorAll('img')].filter(img => !img.complete));
  const primeAfterPaint = () => {
    if (!alive || primed || priming || pending.size) return;
    priming = true;
    clearTimeout(imageDeadline);
    paintFrame = requestAnimationFrame(() => {
      paintFrame = requestAnimationFrame(() => {
        startDelay = setTimeout(() => { primed = true; update(); }, 250);
      });
    });
  };
  for (const img of pending) {
    const ready = () => { pending.delete(img); primeAfterPaint(); };
    listen(img, 'load', ready);
    listen(img, 'error', ready);
  }
  imageDeadline = setTimeout(() => {
    if (!primed && pending.size && !paused) fallback('images-pending');
  }, 5000);
  primeAfterPaint();
  updateLabels();

  return () => {
    alive = false;
    events.abort();
    observer?.disconnect();
    clearTimeout(imageDeadline);
    clearTimeout(startDelay);
    cancelAnimationFrame(paintFrame);
    releaseVideo();
  };
}

  if (!customElements.get('rk-wandor-hero')) {
    customElements.define('rk-wandor-hero', class extends HTMLElement {
      connectedCallback() {
        this.mediaCleanup?.();
        this.mediaCleanup = mountHeroMedia(this);
        this.resizeObserver?.disconnect();
        this.resizeObserver = new ResizeObserver(() => this.updateLeafArea());
        this.resizeObserver.observe(this);
        this.resizeObserver.observe(this.querySelector('.rk-fall-hero__body'));
        const link = this.querySelector('[data-offers-link]');
        const target = document.querySelector('[id^="fall-offers-v2-"]');
        if (link && target) link.setAttribute('href', '#' + target.id);
        if (!target && link) {
          this.readyListener = () => {
            const offers = document.querySelector('[id^="fall-offers-v2-"]');
            if (offers) link.setAttribute('href', '#' + offers.id);
          };
          document.addEventListener('DOMContentLoaded', this.readyListener, { once: true });
        }
      }
      updateLeafArea() {
        const copy = this.querySelector('.rk-fall-hero__copy');
        const bounds = this.getBoundingClientRect();
        const top = Math.max(260, copy ? copy.getBoundingClientRect().bottom - bounds.top + 12 : 260);
        this.style.setProperty('--rk-leaves-top', top + 'px');
        this.style.setProperty('--leaf-travel', Math.max(80, bounds.height - top + 80) + 'px');
      }
      disconnectedCallback() {
        this.mediaCleanup?.();
        this.resizeObserver?.disconnect();
        if (this.readyListener) document.removeEventListener('DOMContentLoaded', this.readyListener);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reelmark-offers"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('reelmark-offers')) return;

  class ReelmarkOffers extends HTMLElement {
    connectedCallback() {
      if (this._controller || this._connectFrame) return;
      if (!this.querySelector('[data-viewport]') || !this.querySelector('[data-track]')) {
        this._connectFrame = requestAnimationFrame(() => {
          this._connectFrame = 0;
          if (this.isConnected && this.querySelector('[data-viewport]')) this.connectedCallback();
        });
        return;
      }

      this._controller = new AbortController();
      const signal = this._controller.signal;
      this._viewport = this.querySelector('[data-viewport]');
      this._track = this.querySelector('[data-track]');
      this._track.querySelectorAll('[data-carousel-clone]').forEach(element => element.remove());
      this._cards = [...this._track.querySelectorAll('[data-card]')].map((element, index) => ({
        element,
        index,
        cycle: 0,
        video: element.querySelector('video'),
        details: element.querySelector('[data-card-details]'),
        visible: true,
        wantsVideo: false,
        frame: 0
      }));
      this._previous = this.querySelector('[data-prev]');
      this._next = this.querySelector('[data-next]');
      this._pause = this.querySelector('[data-pause]');
      this._controls = this.querySelector('.rm-offers__controls');
      this._autoplay = this.dataset.autoplay === 'true';
      this._videoAutoplay = this.dataset.videoAutoplay === 'true';
      this._speed = Math.max(0, Math.min(150, Number(this.dataset.speed) || 0));
      this._looping = this._cards.length >= 2;
      this._renderCards = [...this._cards];
      this._createLoopCopies(signal);
      this._offset = 0;
      this._velocity = 0;
      this._lastTime = 0;
      this._manualPaused = this.dataset.editor === 'true';
      this._hovered = false;
      this._focused = this.contains(document.activeElement) && !this._pause?.contains(document.activeElement);
      this._inView = false;
      this._selectedBlock = '';
      this._pointer = null;
      this._suppressClickUntil = 0;
      this._entranceAnimations = [];
      this._reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this._tick = this._tick.bind(this);

      this._renderCards.forEach(card => {
        if (!card.video) return;
        card.video.removeAttribute('autoplay');
        card.video.muted = true;
        card.video.defaultMuted = true;
        card.video.playsInline = true;
        card.video.preload = 'none';
        card.video.addEventListener('playing', () => this._revealVideo(card), { signal });
        card.video.addEventListener('error', () => card.element.classList.remove('is-video-ready'), { signal });
      });

      this._viewport.addEventListener('pointerdown', event => this._pointerDown(event), { signal });
      this._viewport.addEventListener('pointermove', event => this._pointerMove(event), { signal, passive: false });
      this._viewport.addEventListener('pointerup', event => this._pointerUp(event), { signal });
      this._viewport.addEventListener('pointercancel', event => this._pointerUp(event, true), { signal });
      document.addEventListener('pointerup', event => this._pointerUp(event), { signal });
      document.addEventListener('pointercancel', event => this._pointerUp(event, true), { signal });
      this._viewport.addEventListener('dragstart', event => event.preventDefault(), { signal });
      this._viewport.addEventListener('lostpointercapture', event => {
        if (this._pointer && this._pointer.id === event.pointerId) this._pointerUp(event, true);
      }, { signal });
      this._viewport.addEventListener('click', event => {
        if (event.detail !== 0 && performance.now() < this._suppressClickUntil) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, { signal, capture: true });
      this._viewport.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          if (event.target !== this._viewport) this._viewport.focus({ preventScroll: true });
          this._navigate(event.key === 'ArrowLeft' ? 1 : -1);
        } else if (event.key === ' ' && event.target === this._viewport && this._pause && !this._pause.hidden) {
          event.preventDefault();
          this._togglePause();
        }
      }, { signal });

      this._viewport.addEventListener('pointerenter', event => {
        if (event.pointerType !== 'mouse') return;
        this._hovered = true;
        this._refresh();
      }, { signal });
      this._viewport.addEventListener('pointerleave', event => {
        if (event.pointerType !== 'mouse') return;
        this._hovered = false;
        this._refresh();
      }, { signal });
      this.addEventListener('focusin', event => {
        this._focused = !this._pause?.contains(event.target);
        this._refresh();
      }, { signal });
      this.addEventListener('focusout', event => {
        this._focused = Boolean(event.relatedTarget && this.contains(event.relatedTarget) && !this._pause?.contains(event.relatedTarget));
        this._refresh();
      }, { signal });
      this._previous?.addEventListener('click', () => this._navigate(1), { signal });
      this._next?.addEventListener('click', () => this._navigate(-1), { signal });
      this._pause?.addEventListener('click', () => this._togglePause(), { signal });
      document.addEventListener('visibilitychange', () => this._refresh(), { signal });
      this._reducedMotion.addEventListener('change', () => this._refresh(), { signal });
      document.addEventListener('shopify:block:select', event => this._selectBlock(event), { signal });
      document.addEventListener('shopify:block:deselect', event => {
        if (!this._eventBelongsHere(event)) return;
        this._selectedBlock = '';
        this._refresh();
      }, { signal });

      const canMoveRail = this._looping && this._autoplay && this._speed > 0;
      const canMoveVideo = this._videoAutoplay && this._cards.some(card => card.video);
      if (this._controls) this._controls.hidden = this._cards.length <= 1 && !canMoveVideo;
      if (this._previous) this._previous.hidden = this._cards.length <= 1;
      if (this._next) this._next.hidden = this._cards.length <= 1;
      if (this._pause) this._pause.hidden = !canMoveRail && !canMoveVideo;
      this._resizeObserver = new ResizeObserver(() => this._resize());
      this._resizeObserver.observe(this._viewport);
      if ('IntersectionObserver' in window) {
        this._intersectionObserver = new IntersectionObserver(entries => {
          const entry = entries[entries.length - 1];
          this._inView = entry.isIntersecting && entry.intersectionRatio > 0;
          if (this._inView) this._entrance();
          this._refresh();
        }, { threshold: 0 });
        this._intersectionObserver.observe(this._viewport);
      } else {
        this._inView = true;
        this._entrance();
      }
      this._resize();
      this._refresh();
    }

    disconnectedCallback() {
      if (this._connectFrame) cancelAnimationFrame(this._connectFrame);
      this._connectFrame = 0;
      if (!this._controller) return;
      this._controller.abort();
      this._controller = null;
      if (this._animationFrame) cancelAnimationFrame(this._animationFrame);
      this._animationFrame = 0;
      this._resizeObserver?.disconnect();
      this._intersectionObserver?.disconnect();
      this._entranceAnimations.forEach(animation => animation.cancel());
      this._entranceAnimations = [];
      this._renderCards.forEach(card => {
        card.video?.pause();
        if (card.frame && card.video?.cancelVideoFrameCallback) card.video.cancelVideoFrameCallback(card.frame);
        card.frame = 0;
        card.wantsVideo = false;
      });
      this._renderCards.filter(card => card.cycle).forEach(card => card.element.remove());
      this._renderCards = [...this._cards];
      this._pointer = null;
      this.classList.remove('is-dragging');
      this._viewport.classList.remove('is-dragging');
    }

    _createLoopCopies(signal) {
      const count = this._cards.length;
      if (count < 2 || count >= 7) return;
      // Keep real cards in the central period for keyboard access. Identical,
      // non-semantic copies fill the edges when the product count is small.
      const cycles = Math.ceil((7 / count - 1) / 2);
      for (let cycle = -cycles; cycle <= cycles; cycle += 1) {
        if (!cycle) continue;
        this._cards.forEach(source => {
          const element = source.element.cloneNode(true);
          element.removeAttribute('data-card');
          element.dataset.carouselClone = 'true';
          element.setAttribute('aria-hidden', 'true');
          element.classList.remove('is-video-ready');
          [element, ...element.querySelectorAll('*')].forEach(node => {
            node.removeAttribute('id');
            node.removeAttribute('data-block-id');
            ['for', 'aria-labelledby', 'aria-describedby', 'aria-controls', 'aria-owns', 'aria-activedescendant', 'aria-flowto', 'aria-details', 'aria-errormessage', 'headers'].forEach(attribute => node.removeAttribute(attribute));
            [...node.attributes].forEach(attribute => {
              if (attribute.name.startsWith('data-shopify-')) node.removeAttribute(attribute.name);
            });
            if (node.matches('a, area, button, input, select, textarea, iframe, audio, video, [tabindex], [contenteditable]')) {
              node.setAttribute('tabindex', '-1');
              if (node.hasAttribute('contenteditable')) node.setAttribute('contenteditable', 'false');
            }
          });
          // A mouse click may still follow the copy's link, without putting
          // keyboard focus inside its aria-hidden subtree.
          element.addEventListener('mousedown', event => {
            if (event.button === 0) event.preventDefault();
          }, { signal });
          element.addEventListener('focusin', () => this._viewport.focus({ preventScroll: true }), { signal });
          this._track.append(element);
          this._renderCards.push({
            element,
            index: source.index,
            cycle,
            video: element.querySelector('video'),
            details: element.querySelector('[data-card-details]'),
            visible: true,
            wantsVideo: false,
            frame: 0
          });
        });
      }
    }

    _resize() {
      if (!this._controller) return;
      const width = this._viewport.clientWidth;
      if (!width) return;
      this._mobile = width <= 820;
      this._viewWidth = this._mobile ? 640 : 1440;
      this._scale = Math.min(width / this._viewWidth, 1);
      this._bandHeight = this._mobile ? 250 : 420 * this._scale;
      this._centre = this._viewWidth / 2;
      this._normalizer = this._centre - 14;
      this._pitch = this._cards.length === 7 ? 224 : 216;
      this._period = this._cards.length * this._pitch;
      this.style.setProperty('--rm-band-height', `${this._bandHeight}px`);
      this.style.setProperty('--rm-text-size', `${(this._mobile ? 13 : 16) / this._scale}px`);
      this._track.style.width = `${this._viewWidth}px`;
      this._track.style.height = `${this._bandHeight / this._scale}px`;
      this._track.style.transform = `translate3d(${Math.max(0, (width - this._viewWidth * this._scale) / 2)}px,0,0) scale(${this._scale})`;
      this._offset = this._constrain(this._offset);
      this.classList.add('is-ready');
      this._render();
    }

    _constrain(offset) {
      if (this._looping) return ((offset % this._period) + this._period) % this._period;
      const limit = Math.max(0, (this._cards.length - 1) * this._pitch / 2);
      return Math.max(-limit, Math.min(limit, offset));
    }

    _position(index, cycle = 0) {
      const position = (index - (this._cards.length - 1) / 2) * this._pitch + this._offset;
      if (!this._looping) return position;
      return ((position + this._period / 2) % this._period + this._period) % this._period - this._period / 2 + cycle * this._period;
    }

    _roundedQuad(width, height, leftHeight, rightHeight) {
      const points = [[0, (height - leftHeight) / 2], [width, (height - rightHeight) / 2], [width, (height + rightHeight) / 2], [0, (height + leftHeight) / 2]];
      const corners = points.map((point, index) => {
        const previous = points[(index + 3) % 4];
        const next = points[(index + 1) % 4];
        const previousLength = Math.hypot(previous[0] - point[0], previous[1] - point[1]);
        const nextLength = Math.hypot(next[0] - point[0], next[1] - point[1]);
        const radius = Math.min(15, previousLength / 2, nextLength / 2);
        return {
          point,
          before: [point[0] + (previous[0] - point[0]) * radius / previousLength, point[1] + (previous[1] - point[1]) * radius / previousLength],
          after: [point[0] + (next[0] - point[0]) * radius / nextLength, point[1] + (next[1] - point[1]) * radius / nextLength]
        };
      });
      let path = `M${corners[0].before.join(',')}`;
      corners.forEach((corner, index) => {
        if (index) path += `L${corner.before.join(',')}`;
        path += `Q${corner.point.join(',')} ${corner.after.join(',')}`;
      });
      return `path("${path}Z")`;
    }

    _render() {
      if (!this._scale || !this._controller) return;
      const middleY = this._bandHeight / this._scale / 2;
      this._renderCards.forEach(card => {
        const position = this._position(card.index, card.cycle);
        // Cull distant loop copies before the curved projection can amplify
        // their dimensions enough to intersect the viewport again.
        if (Math.abs(position) > this._viewWidth / 2 + this._pitch) {
          card.visible = false;
          card.element.style.display = 'none';
          return;
        }
        const x = this._centre + position * (1 + 0.083 * (position / this._normalizer) ** 2);
        const distance = Math.abs(x - this._centre) / this._normalizer;
        const width = 190 + 48 * distance * distance;
        card.visible = x + width / 2 > 0 && x - width / 2 < this._viewWidth;
        card.element.style.display = card.visible ? '' : 'none';
        if (!card.visible) return;
        const leftHeight = 300 + 92 * (Math.abs(x - width / 2 - this._centre) / this._normalizer) ** 2.6;
        const rightHeight = 300 + 92 * (Math.abs(x + width / 2 - this._centre) / this._normalizer) ** 2.6;
        const height = Math.max(leftHeight, rightHeight);
        const y = middleY - 12 * distance * distance;
        const safeBottom = (height - Math.min(leftHeight, rightHeight)) / 2;
        card.element.style.width = `${width}px`;
        card.element.style.height = `${height}px`;
        card.element.style.transform = `translate3d(${x - width / 2}px,${y - height / 2}px,0)`;
        card.element.style.clipPath = this._roundedQuad(width, height, leftHeight, rightHeight);
        card.element.style.setProperty('--rm-safe-bottom', `${safeBottom}px`);
        if (card.details) card.details.style.bottom = `${safeBottom + 16 / this._scale}px`;
      });
      this._updateNavigation();
      this._syncVideos();
    }

    _isBlocked() {
      return this._manualPaused || document.hidden || !this._inView || Boolean(this._selectedBlock) || this._reducedMotion.matches;
    }

    _isSoftPaused() {
      return this._hovered || this._focused;
    }

    _refresh() {
      if (!this._controller) return;
      this._lastTime = 0;
      if (this._isBlocked()) this._velocity = 0;
      if (this._reducedMotion.matches) {
        this._entranceAnimations.forEach(animation => animation.cancel());
        this._entranceAnimations = [];
      }
      if (this._pause) {
        const paused = this._manualPaused || Boolean(this._selectedBlock) || this._reducedMotion.matches;
        const label = this._reducedMotion.matches
          ? (this.dataset.reducedMotionLabel || 'Motion paused (reduced motion enabled)')
          : paused ? (this.dataset.playLabel || 'Play motion') : (this.dataset.pauseLabel || 'Pause motion');
        this._pause.setAttribute('aria-label', label);
        this._pause.setAttribute('title', label);
        this._pause.setAttribute('aria-pressed', String(paused));
        this._pause.dataset.paused = String(paused);
        this._pause.disabled = this._reducedMotion.matches;
      }
      this._syncVideos();
      this._requestTick();
    }

    _togglePause() {
      if (this._reducedMotion.matches) return;
      const shouldPlay = this._manualPaused || Boolean(this._selectedBlock);
      this._manualPaused = !shouldPlay;
      if (shouldPlay) this._selectedBlock = '';
      this._refresh();
    }

    _entrance() {
      if (this._entrancePlayed) return;
      this._entrancePlayed = true;
      if (this.dataset.entrance !== 'true' || this.dataset.editor === 'true' || this._reducedMotion.matches || typeof this.animate !== 'function') return;
      [
        [this.querySelector('.rm-offers__header'), 0, 14],
        [this._viewport, 110, 18],
        [this.querySelector('.rm-offers__footer'), 220, 10]
      ].forEach(([element, delay, rise]) => {
        if (!element) return;
        this._entranceAnimations.push(element.animate([
          { opacity: 0, transform: `translateY(${rise}px)` },
          { opacity: 1, transform: 'translateY(0)' }
        ], { duration: 650, delay, easing: 'cubic-bezier(.16,1,.3,1)', fill: 'backwards' }));
      });
      this.querySelectorAll('.rm-offers__note path, .rm-offers__slashes path').forEach((path, index) => {
        if (typeof path.getTotalLength !== 'function') return;
        const length = path.getTotalLength();
        if (!length) return;
        this._entranceAnimations.push(path.animate([
          { strokeDasharray: `${length} ${length}`, strokeDashoffset: length },
          { strokeDasharray: `${length} ${length}`, strokeDashoffset: 0 }
        ], { duration: 700, delay: 300 + index * 60, easing: 'ease-out', fill: 'backwards' }));
      });
    }

    _syncVideos() {
      if (!this._renderCards) return;
      const allowed = this._videoAutoplay && !this._isBlocked() && !this._isSoftPaused() && !this._pointer;
      this._renderCards.forEach(card => {
        const video = card.video;
        if (!video) return;
        const wanted = allowed && card.visible;
        if (wanted === card.wantsVideo) return;
        card.wantsVideo = wanted;
        if (!wanted) {
          video.pause();
          return;
        }
        let changed = false;
        if (video.dataset.src && !video.getAttribute('src')) {
          video.src = video.dataset.src;
          changed = true;
        }
        video.querySelectorAll('source[data-src]').forEach(source => {
          if (!source.getAttribute('src')) {
            source.src = source.dataset.src;
            changed = true;
          }
        });
        if (changed) video.load();
        const promise = video.play();
        if (promise && typeof promise.catch === 'function') promise.catch(() => {});
      });
    }

    _revealVideo(card) {
      if (!card.wantsVideo || !this._controller) return;
      if (card.video.requestVideoFrameCallback) {
        if (card.frame) card.video.cancelVideoFrameCallback(card.frame);
        card.frame = card.video.requestVideoFrameCallback(() => {
          card.frame = 0;
          if (card.wantsVideo && this._controller) card.element.classList.add('is-video-ready');
        });
      } else {
        card.element.classList.add('is-video-ready');
      }
    }

    _requestTick() {
      if (this._animationFrame || !this._controller || this._isBlocked() || this._pointer) return;
      if (!(this._looping && this._autoplay && this._speed > 0 && !this._isSoftPaused()) && Math.abs(this._velocity) < 1) return;
      this._animationFrame = requestAnimationFrame(this._tick);
    }

    _tick(time) {
      this._animationFrame = 0;
      if (!this._controller || this._isBlocked() || this._pointer) {
        this._lastTime = 0;
        return;
      }
      const elapsed = this._lastTime ? Math.max(0, (time - this._lastTime) / 1000) : 0;
      this._lastTime = time;
      const decay = Math.pow(0.05, elapsed);
      const inertia = this._velocity * (1 - decay) / -Math.log(0.05);
      const autoplay = this._looping && this._autoplay && !this._isSoftPaused() ? -this._speed * elapsed : 0;
      const intendedOffset = this._offset + autoplay + inertia;
      this._offset = this._constrain(intendedOffset);
      this._velocity *= decay;
      if (!this._looping && this._offset !== intendedOffset) this._velocity = 0;
      this._render();
      this._requestTick();
    }

    _pointerDown(event) {
      if (this._cards.length <= 1 || this._pointer || (event.pointerType === 'mouse' && event.button !== 0)) return;
      if (event.target.closest('button, input, select, textarea')) return;
      this._velocity = 0;
      this._pointer = { id: event.pointerId, startX: event.clientX, lastX: event.clientX, lastTime: event.timeStamp, startOffset: this._offset, dragged: false, velocity: 0 };
      this._syncVideos();
    }

    _pointerMove(event) {
      const pointer = this._pointer;
      if (!pointer || pointer.id !== event.pointerId || !this._scale) return;
      const total = event.clientX - pointer.startX;
      if (!pointer.dragged && Math.abs(total) < 6) return;
      if (!pointer.dragged) {
        pointer.dragged = true;
        this.classList.add('is-dragging');
        this._viewport.classList.add('is-dragging');
        try { this._viewport.setPointerCapture(event.pointerId); } catch (_) {}
      }
      event.preventDefault();
      const elapsed = Math.max(8, event.timeStamp - pointer.lastTime) / 1000;
      const delta = (event.clientX - pointer.lastX) / this._scale;
      pointer.velocity = 0.35 * pointer.velocity + 0.65 * delta / elapsed;
      this._offset = this._constrain(pointer.startOffset + total / this._scale);
      pointer.lastX = event.clientX;
      pointer.lastTime = event.timeStamp;
      this._render();
    }

    _pointerUp(event, cancelled = false) {
      const pointer = this._pointer;
      if (!pointer || pointer.id !== event.pointerId) return;
      this._pointer = null;
      this.classList.remove('is-dragging');
      this._viewport.classList.remove('is-dragging');
      if (pointer.dragged) this._suppressClickUntil = performance.now() + 400;
      this._velocity = !cancelled && pointer.dragged && event.timeStamp - pointer.lastTime < 100 && !this._isBlocked() ? Math.max(-2800, Math.min(2800, pointer.velocity)) : 0;
      try {
        if (this._viewport.hasPointerCapture(event.pointerId)) this._viewport.releasePointerCapture(event.pointerId);
      } catch (_) {}
      this._lastTime = 0;
      this._syncVideos();
      this._requestTick();
    }

    _navigate(direction) {
      if (this._cards.length <= 1) return;
      this._velocity = 0;
      this._offset = this._constrain(this._offset + direction * this._pitch);
      this._render();
    }

    _updateNavigation() {
      const limit = (this._cards.length - 1) * this._pitch / 2;
      if (this._previous) this._previous.disabled = this._cards.length <= 1 || (!this._looping && this._offset >= limit - 0.5);
      if (this._next) this._next.disabled = this._cards.length <= 1 || (!this._looping && this._offset <= -limit + 0.5);
    }

    _eventBelongsHere(event) {
      const detail = event.detail || {};
      if (detail.sectionId != null) return String(detail.sectionId) === this.dataset.sectionId;
      if (event.target instanceof Element && event.target.closest('reelmark-offers') === this) return true;
      return this._cards.some(card => card.element.dataset.blockId === String(detail.blockId || ''));
    }

    _selectBlock(event) {
      if (!this._eventBelongsHere(event)) return;
      const blockId = String(event.detail?.blockId || '');
      const card = this._cards.find(item => item.element.dataset.blockId === blockId || item.element === event.target || item.element.contains(event.target));
      if (!card) return;
      this._selectedBlock = card.element.dataset.blockId || blockId || String(card.index);
      this._velocity = 0;
      this._offset = this._constrain(this._offset - this._position(card.index));
      this._render();
      this._refresh();
    }
  }

  customElements.define('reelmark-offers', ReelmarkOffers);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rk-hdr-compare"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rkx-hdr-compare')) {
    class RkxHdrCompare extends HTMLElement {
      connectedCallback() {
        if (this.abortController || this.initFrame) return;
        this.initFrame = requestAnimationFrame(() => {
          this.initFrame = 0;
          if (this.isConnected) this.init();
        });
      }

      init() {
        this.box = this.querySelector('.rkx-media');
        this.frame = this.querySelector('.rkx-media-frame');
        if (!this.box || !this.frame) return;
        this.handle = this.querySelector('.rkx-handle');
        this.divider = this.querySelector('.rkx-divider');
        this.copy = this.querySelector('.rkx-copy');
        this.spec = this.querySelector('.rkx-spec-bar');
        this.caption = this.querySelector('.rkx-caption');
        this.pointerId = null;
        this.canCompare = false;
        this.value = Number(this.handle?.getAttribute('aria-valuenow') ?? 55);
        this.abortController = new AbortController();
        const signal = this.abortController.signal;
        const images = Array.from(this.querySelectorAll('.rkx-img'));
        const refreshImages = () => {
          images.forEach(img => { img.hidden = img.complete && img.naturalWidth === 0; });
          const beforeReady = images.some(img => img.classList.contains('rkx-before') && img.complete && img.naturalWidth > 0);
          const afterReady = images.some(img => img.classList.contains('rkx-after') && img.complete && img.naturalWidth > 0);
          this.canCompare = beforeReady && afterReady && Boolean(this.handle);
          this.box.dataset.state = this.canCompare ? 'compare' : beforeReady ? 'before' : afterReady ? 'after' : 'empty';
          if (this.handle) this.handle.hidden = !this.canCompare;
          if (this.divider) this.divider.hidden = !this.canCompare;
          if (!this.canCompare) this.stopDrag();
          this.setValue(this.value);
        };
        images.forEach(img => {
          img.draggable = false;
          img.addEventListener('load', refreshImages, { signal });
          img.addEventListener('error', refreshImages, { signal });
        });
        const watermark = this.querySelector('.rkx-watermark');
        if (watermark) {
          watermark.hidden = watermark.complete && watermark.naturalWidth === 0;
          watermark.addEventListener('error', () => { watermark.hidden = true; }, { signal });
          watermark.addEventListener('load', () => { watermark.hidden = false; }, { signal });
        }
        refreshImages();
        this.box.addEventListener('dragstart', event => event.preventDefault(), { signal });
        this.box.addEventListener('pointerdown', event => this.startDrag(event), { signal });
        window.addEventListener('pointermove', event => this.moveDrag(event), { signal, capture: true });
        window.addEventListener('pointerup', event => this.endDrag(event), { signal, capture: true });
        window.addEventListener('pointercancel', event => { if (event.pointerId === this.pointerId) this.stopDrag(); }, { signal, capture: true });
        this.box.addEventListener('lostpointercapture', event => { if (event.pointerId === this.pointerId) this.stopDrag(); }, { signal });
        window.addEventListener('blur', () => this.stopDrag(), { signal });
        document.addEventListener('visibilitychange', () => { if (document.hidden) this.stopDrag(); }, { signal });
        this.handle?.addEventListener('keydown', event => this.onKeydown(event), { signal });
        window.addEventListener('resize', () => this.scheduleFit(), { signal });
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.scheduleFit());
          [this, this.copy, this.spec, this.caption].filter(Boolean).forEach(el => this.resizeObserver.observe(el));
        }
        if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches && !window.Shopify?.designMode) {
          this.revealObserver = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('in');
              this.revealObserver.unobserve(entry.target);
            });
          }, { threshold: .1 });
          this.querySelectorAll('.rkx-reveal:not(.in)').forEach(el => this.revealObserver.observe(el));
        }
        this.scheduleFit();
      }

      setValue(value) {
        if (!Number.isFinite(value)) return;
        this.value = Math.max(0, Math.min(100, value));
        this.box.style.setProperty('--rkx-x', `${this.value.toFixed(2)}%`);
        if (this.handle) {
          const before = Math.round(this.value);
          this.handle.setAttribute('aria-valuenow', String(before));
          this.handle.setAttribute('aria-valuetext', `${this.handle.dataset.beforeLabel} ${before}%, ${this.handle.dataset.afterLabel} ${100 - before}%`);
        }
        const beforeTag = this.box.querySelector('.rkx-tag-before');
        const afterTag = this.box.querySelector('.rkx-tag-after');
        if (beforeTag) beforeTag.hidden = this.canCompare && this.value <= 0;
        if (afterTag) afterTag.hidden = this.canCompare && this.value >= 100;
      }

      setFromPointer(clientX) {
        const rect = this.box.getBoundingClientRect();
        const width = rect.width - this.box.clientLeft * 2;
        if (width > 0) this.setValue(((clientX - this.dragOffset - rect.left - this.box.clientLeft) / width) * 100);
      }

      startDrag(event) {
        if (!this.canCompare || !event.isPrimary || event.button !== 0 || this.pointerId !== null) return;
        this.pointerId = event.pointerId;
        this.startX = event.clientX;
        this.startY = event.clientY;
        const fromHandle = this.handle.contains(event.target);
        const rect = this.box.getBoundingClientRect();
        this.dragOffset = fromHandle ? event.clientX - rect.left - this.box.clientLeft - ((rect.width - this.box.clientLeft * 2) * this.value / 100) : 0;
        this.touchPending = event.pointerType === 'touch' && !fromHandle;
        if (event.pointerType !== 'touch') event.preventDefault();
        try { this.box.setPointerCapture(event.pointerId); } catch {}
        if (!this.touchPending) {
          this.handle.focus({ preventScroll: true });
          this.box.classList.add('is-dragging');
          if (!fromHandle) this.setFromPointer(event.clientX);
        }
      }

      moveDrag(event) {
        if (event.pointerId !== this.pointerId) return;
        if (event.pointerType === 'mouse' && (event.buttons & 1) === 0) { this.stopDrag(); return; }
        if (this.touchPending) {
          const dx = Math.abs(event.clientX - this.startX);
          const dy = Math.abs(event.clientY - this.startY);
          if (dy > 6 && dy > dx) { this.stopDrag(); return; }
          if (dx < 6 || dx < dy) return;
          this.touchPending = false;
          this.handle.focus({ preventScroll: true });
          this.box.classList.add('is-dragging');
        }
        this.setFromPointer(event.clientX);
      }

      endDrag(event) {
        if (event.pointerId !== this.pointerId) return;
        if (!this.touchPending || Math.hypot(event.clientX - this.startX, event.clientY - this.startY) <= 6) this.setFromPointer(event.clientX);
        this.stopDrag();
      }

      stopDrag() {
        const pointerId = this.pointerId;
        this.pointerId = null;
        this.touchPending = false;
        this.box?.classList.remove('is-dragging');
        if (pointerId == null) return;
        try { if (this.box.hasPointerCapture(pointerId)) this.box.releasePointerCapture(pointerId); } catch {}
      }

      onKeydown(event) {
        if (!this.canCompare) return;
        const step = event.shiftKey ? 10 : 1;
        const values = { ArrowLeft: this.value - step, ArrowDown: this.value - step, ArrowRight: this.value + step, ArrowUp: this.value + step, PageDown: this.value - 10, PageUp: this.value + 10, Home: 0, End: 100 };
        if (!(event.key in values)) return;
        event.preventDefault();
        this.setValue(values[event.key]);
      }

      scheduleFit() {
        if (this.fitFrame) return;
        this.fitFrame = requestAnimationFrame(() => { this.fitFrame = 0; if (this.isConnected) this.fitMedia(); });
      }

      fitMedia() {
        const compact = window.innerWidth <= 749 || this.clientWidth < 600;
        this.classList.toggle('rkx-compact', compact);
        if (compact || this.dataset.layout !== 'compact') { this.frame.style.removeProperty('--rkx-frame-width'); return; }
        const style = getComputedStyle(this);
        const maxWidth = Math.min(this.clientWidth, parseFloat(style.getPropertyValue('--rkx-media-max')) || 1140);
        const padding = parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
        const copyHeight = this.copy?.offsetHeight || 0;
        const rows = [this.spec, this.caption].filter(Boolean).length;
        const frameGap = parseFloat(getComputedStyle(this.frame).rowGap) || 12;
        const available = (parseFloat(style.getPropertyValue('--rkx-height')) || 820) - padding - copyHeight - (copyHeight ? parseFloat(style.rowGap) || 24 : 0) - (this.spec?.offsetHeight || 0) - (this.caption?.offsetHeight || 0) - frameGap * rows;
        const width = Math.round(Math.min(maxWidth, Math.max(Math.min(320, maxWidth), available * 16 / 9)));
        if (Math.abs(this.frame.getBoundingClientRect().width - width) > 1) this.frame.style.setProperty('--rkx-frame-width', `${width}px`);
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        cancelAnimationFrame(this.fitFrame);
        this.initFrame = 0;
        this.fitFrame = 0;
        this.stopDrag();
        this.abortController?.abort();
        this.abortController = null;
        this.resizeObserver?.disconnect();
        this.revealObserver?.disconnect();
      }
    }
    customElements.define('rkx-hdr-compare', RkxHdrCompare);
  }

  } catch(e) { console.error(e); }
})();
})();
